export const handbookCopy = {
	handb_prev: "Sebelumnya",
	handb_next: "Selanjutnya",
}
